import { environment } from "src/environments/environment";

/**
 * True za zahteve ka eMeni backend-u — kojima interceptori smeju da dodaju header-e
 * (JWT, app verzija, udid). Pokriva:
 *  - relativne URL-ove (`/api/...`, isti origin i preko dev proxy-ja),
 *  - sopstveni backend host iz environment-a, uključujući hostove SA portom
 *    (localhost:4204 u dev-u, LAN LocalServer 192.168.x.x:5080),
 *  - bilo koji eMeni domen nezavisno od TLD-a (emeni.rs, emeni.it, emeni.me, emeni.com, ...)
 *    i poddomena (app./konobar./dostava./app.dev. ...).
 *
 * Poređenje sa environment.host ide po CELOM host-u (sa portom) — obe strane potiču iz
 * window.location, pa su simetrične; skidanje porta samo sa jedne strane ovde je ranije
 * tiho gasilo header-e na localhost/LAN dev-u. Regex je usidren na kraj hostname-a i traži
 * jedan TLD label, pa `emeni.rs.evil.com` NE prolazi (header-i/token ne cure trećim
 * stranama poput maps.googleapis.com).
 */
export function isEmeniBackendUrl(url: string): boolean {
  if (!/^https?:\/\//i.test(url)) {
    return true; // relativni URL — naš origin
  }
  try {
    const u = new URL(url);
    return u.host === environment.host
      || /(^|\.)emeni\.[a-z]{2,}$/i.test(u.hostname);
  } catch {
    return false;
  }
}
